import * as React from 'react';
import QuantityForm from './Quantity';
import DiscountForm from './Discount';

interface IFormProps {
  children?: any;
  type?: string;
  onVoucher?: (voucher: string) => void;
}

const Form = (props: IFormProps) => {
  const name: string = 'form';
  const { children, type } = props;

  switch (type) {
    case 'quantity':
      return (
        // @ts-ignore
        <QuantityForm />
      );
    case 'discount':
      return <DiscountForm onVoucher={props.onVoucher} />;
    default:
      return <form className={name + (type ? ' ' + name + '--' + type : '')}>{children}</form>;
  }
};

export default Form;



// WEBPACK FOOTER //
// ./src/modules/Form/Form.tsx